const currencyFormater = (number: number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 2,
  });

  return formatter.format(number);
};

export { currencyFormater };
